export const Archivements = [
  {
    year: "Jul 2023",
    title: "3 Stars at CodeChef",
    description: "Highest rating - 1611",
    link: "https://www.codechef.com/users/yash_sajwan",
  },
  {
    year: "Mar 2023",
    title: "400+ problems",
    description: "Solved 400+ problems on Leetcode",
    link: "https://leetcode.com/yash_sajwan/",
  },
  {
    year: "Nov 2022",
    title: "Solana x Superteam HackDay Hackathon",
    description: "In the top 10 Winning Teams Nationally",
    link: "https://devfolio.co/projects/organise-0ff0",
  },
  {
    year: "Sep 2022",
    title: "Innerve Hacks Hackathon",
    description: "Finalist out of 3600+ participants at IGDTUW",
    link: "https://drive.google.com/file/d/1YODNDLS2mjVwfsB-4A1C2cZ9qnmrLMWD/view",
  },
  {
    year: "Jul 2022",
    title: "Google Cloud",
    description: "30 Days Of Google Cloud with 70+ labs.",
    link: "https://www.cloudskillsboost.google/public_profiles/7daa0c81-ef98-4625-bcc9-01ecbbc6053e",
  },
  {
    year: "Sep 2022",
    title: "Hacktoberfest",
    description: "Merged 7 PRs to Open Source Organisations.",
    link: "https://www.holopin.io/@yash_sajwan",
  }
];
